import React, { useEffect, useState } from "react";
import { ServicesDropdownComponent } from "./services-dropdown.component";
import { BrandComponent } from "./brand.component";
import { Helmet } from "react-helmet-async";
import { metaMap } from "../../utils/meta-tags";
import { navs } from "./nav-items";

interface INavbarComponentProps { }

export const NavbarComponent: React.FC<INavbarComponentProps> = () => {
    const [activeNav, setActiveNav] = useState("Home");
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    useEffect(() => {
        const handleScroll = () => {
            let matchedNav;
            for (const nav of navs) {
                if (!nav.url?.includes("#")) continue;

                const sectionId = nav.url.split("#")[1];
                const sectionElement = document.getElementById(sectionId);
                if (!sectionElement) continue;

                const rect = sectionElement.getBoundingClientRect();
                if (rect.top <= 100 && rect.bottom >= 100) {
                    matchedNav = nav.name;
                    break;
                }
            }

            if (matchedNav) {
                setActiveNav(matchedNav);
            } else if (window.scrollY === 0) {
                setActiveNav("Home");
            } else {
                setActiveNav("");
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 1024 && isSidebarOpen) {
                setIsSidebarOpen(false);
            }
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [isSidebarOpen]);

    return (
        <>
            <Helmet>
                <title>{metaMap[activeNav]?.title || "Home - iTalent"}</title>
                <meta name="description" content={metaMap[activeNav]?.description || "Welcome to iTalent"} />
                <meta name="keywords" content={metaMap[activeNav]?.keywords || "iTalent, services"} />
            </Helmet>

            {/* Top Navbar */}
            <nav id="navmenu" className="navmenu">
                <ul>
                    {navs.map((nav, index) => (
                        <React.Fragment key={index}>
                            {!nav.template ? (
                                <li>
                                    <a
                                        href={nav.url}
                                        className={activeNav === nav.name ? "active gradient-text" : "gradient-text"}
                                        onClick={() => setActiveNav(nav.name)}
                                    >
                                        {nav.name}
                                    </a>
                                </li>
                            ) : (
                                <ServicesDropdownComponent
                                    isActive={activeNav === "Services"}
                                    onClick={() => setActiveNav("Services")}
                                />
                            )}
                        </React.Fragment>
                    ))}
                </ul>
                <i
                    className="mobile-nav-toggle d-xl-none bi bi-list gradient-text"
                    onClick={toggleSidebar}
                    style={{ cursor: "pointer", fontSize: "24px" }}
                ></i>
            </nav>

            {/* Overlay */}
            {isSidebarOpen && (
                <div className="overlay" onClick={toggleSidebar}></div>
            )}

            {/* Sidebar for Mobile */}
            <div className={`sidebar ${isSidebarOpen ? "open" : ""}`}>
                <div className="sidebar-content">
                    <button onClick={toggleSidebar} className="close-btn">×</button>
                    <ul className="list-unstyled px-3">
                        {navs.map((nav, index) => (
                            <React.Fragment key={index}>
                                {!nav.template ? (
                                    <li className="mb-2">
                                        <a
                                            href={nav.url}
                                            onClick={() => {
                                                setActiveNav(nav.name);
                                                setIsSidebarOpen(false);
                                            }}
                                            className={`d-block px-5 py-2 ${activeNav === nav.name ? "text-white" : "text-white-50"}`}
                                            style={{
                                                textDecoration: "none",
                                                fontWeight: activeNav === nav.name ? "500" : "normal",
                                            }}
                                        >
                                            {nav.name}
                                        </a>
                                    </li>
                                ) : (
                                    <ServicesDropdownComponent
                                        isActive={activeNav === "Services"}
                                        onClick={() => {
                                            setActiveNav("Services");
                                            setIsSidebarOpen(false);
                                        }}
                                    />
                                )}
                            </React.Fragment>
                        ))}
                    </ul>
                </div>
            </div>
        </>
    );
};
